import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {LocaleProvider, Form, Select, Collapse, Radio, Checkbox, DatePicker, message, Icon, Button} from 'antd';
import Textarea from '../../components/Textarea';
import s from './SendForm.css';
import {Link} from 'react-router-dom';
import {fetchDecode} from '../../fetchUtils';
import {isValidPhoneNumber, isInvalidPhoneNumber} from "../../phoneNumberUtils";
import history from "../../history";
import enUS from 'antd/lib/locale-provider/en_US';
import Dropzone from 'react-dropzone'
import {userTypes} from "../../UserTypes";
import {withRouter} from "react-router-dom";
import Tooltip from '../../components/Tooltip'
import * as XLSX from 'xlsx';

class SendForm extends React.Component {
    static propTypes = {
        form: PropTypes.object.isRequired,
        locale: PropTypes.object.isRequired,
        numbers: PropTypes.arrayOf(PropTypes.string),
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            userType: userTypes.Einstaklingur,
            number: props.location.state != undefined ? props.location.state.numbers : [],
            files: [],
            invalidNumbers: [],
            group: [],
            sender: '',
            text: '',
            save: false,
            templateSelect: [],
            templateName: '',
            length: 0,
            messages: 1,
            type: 'n',
            report: 'y',
            uni: 'n',
            replace: 'n',
            schedule: 'n',
            date: '',
            groups: [],
            contacts: [],
            templates: [],
            senders_list: [],
            validation: true,
            numberValidation: true,
            textValidation: true,
            defaultValue: [],
            maxMessageSizes: [160, 153],
            maxIcelandicMessageSizes: [70, 67],
            isIsl: false,
            maxMessageCount: 3,
            messageInput: undefined,
            gsmCodes: [10, 13, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49,
                50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72,
                73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 95, 97, 98, 99, 100,
                101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118,
                119, 120, 121, 122, 161, 163, 164, 165, 167, 191, 196, 197, 198, 199, 201, 209, 214, 216,
                220, 223, 224, 228, 229, 230, 232, 233, 236, 241, 242, 246, 248, 249, 252],
            config: require('Config'),
            isSubmitting: false
        };
        this.textChange = this.textChange.bind(this);
        this.saveChange = this.saveChange.bind(this);
        this.sendingRequest = this.sendingRequest.bind(this);
    }

    componentDidMount() {
        this.setState({
            sender: sessionStorage.getItem("default_sender"),
            senders_list: JSON.parse(sessionStorage.getItem("senders_list")),
            userType: sessionStorage.getItem("userType")
        });
        fetchDecode(this.state.config.serverUrl + `groups/all`, message)
            .then(response => this.setState({groups: response}));
        fetchDecode(this.state.config.serverUrl + `contacts/all`, message)
            .then(response => this.setState({contacts: response}));
        if (sessionStorage.getItem("userType") == userTypes.Fyrirtaeki) {
            fetchDecode(this.state.config.serverUrl + `texts/all`, message)
                .then(response => this.setState({templates: response}));
        }
    }

    senderState(value) {
        this.setState({sender: value});
    }

    valueChange(name, value) {
        this.setState({[name]: value});
    }

    checkValidation() {
        const numberValidation = (this.state.number.length > 0 || this.state.files.length > 0);
        const textValidation = this.state.text.length > 0;
        if (!numberValidation) {
            const groupValidation = this.state.group.length > 0;
            if (!groupValidation) {
                this.setState({numberValidation: numberValidation, textValidation: textValidation});
            }
            else {
                this.setState({textValidation: textValidation});
                return groupValidation && textValidation;
            }
        }
        this.setState({numberValidation: numberValidation, textValidation: textValidation});
        return numberValidation && textValidation;
    }

    updateValidation(name, value) {
        var strip = value;
        if (name === 'number'){
            strip = value.map(el => el.replace(/-/g, ''));
            var invalidNumbers = strip.filter(number => (!isValidPhoneNumber(number)));
            strip = strip.filter(number => (isValidPhoneNumber(number)));
            this.valueChange(name, strip);

            var allInvalidNumbers = this.state.invalidNumbers.concat(invalidNumbers);
            this.setState({invalidNumbers: allInvalidNumbers});
        }
        else if(name === 'group' && value.length !== 0){
            var lastItem = strip[strip.length -1]; //only 1 group allowed in the input field, so we use the last one
            this.state.groups.find((element) => {
                if (element.name === lastItem){
                    this.valueChange(name, [lastItem]);
                }
            });
        }
        else{
            this.valueChange(name, strip);
        }
    }

    templateChange(value) {
        this.props.form.setFieldsValue({
            text: value,
        });
        this.setState({
            text: value,
            length: value.length,
            templateSelect: value,
        });
        this.textChange(value);
    }

    getChunkSize(value, isIsl) {
        if (isIsl) {
            return value.length > 70 ? 67 : 70;
        }
        return value.length > 160 ? 153 : 160;
    }

    textChange(value) {
        this.setState({text: value});
    }

    saveChange(value) {
        this.setState({save: value});
    }

    radioChange(name, event) {
        this.setState({[name]: event.target.value});
    }

    checkboxChange(name, event) {
        this.setState({[name]: event.target.checked ? 'y' : 'n'});
    }

    successMessage = (text) => {
        message.success(text, 2);
    };

    errorMessage = (error) => {
        message.error(`${this.props.locale.messageError} ${error}`, 10);
    };

    isGSM = (value) => {
        for (let i = 0; i < value.length; i += 1) {
            if (this.state.gsmCodes.find(code => code === value.charCodeAt(i)) == undefined) return false;
        }
        return true;
    };

    clearForm = (e) => {
        e.preventDefault();
        this.setState({
            number: [],
            group: [],
            sender: this.context.default_sender,
            text: '',
            save: false,
            templateSelect: undefined,
            templateName: '',
            length: 0,
            messages: 1,
            type: 'n',
            report: 'y',
            uni: 'n',
            replace: 'n',
            schedule: 'n',
            date: '',
            validation: true,
            files: []
        });
    };

    sendingRequest = (e) => {
        if (!this.state.isSubmitting){
            e.preventDefault();
            this.setState({isSubmitting: true}); //disable button so user can't accidentally press it multiple times
            this.props.form.validateFields((err) => {
                if (this.checkValidation() && !err) {
                    let numbersToSendTo = this.state.number.concat([].concat.apply([], this.state.files.map(x => x.numbers)))
                    numbersToSendTo = [...new Set(numbersToSendTo)];
                    let isEinstaklingur = this.state.userType == userTypes.Einstaklingur;
                    if (isEinstaklingur && numbersToSendTo.length > 1000) {
                        this.errorMessage("Ekki má senda fleirri en 1000 skeyti í einu");
                        return;
                    }
                    fetch(this.state.config.serverUrl + 'sendForm/push?',
                        {
                            method: 'POST',
                            headers: new Headers({
                                'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
                                'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                                'username': `${sessionStorage.getItem('username')}`
                            }),
                            body: (
                                `${this.state.number.length > 0 || this.state.files.length > 0 ? `&MSISDN=${encodeURIComponent(numbersToSendTo)}` : ''}` +
                                `${this.state.group.length > 0 ? `&group=${encodeURIComponent(this.state.group)}` : ''}` +
                                `&T=${encodeURIComponent(this.state.text)}` +
                                `${this.state.sender ? `&A=${encodeURIComponent(this.state.sender)}` : ''}` +
                                `${this.state.type === 'y' && !isEinstaklingur ? `&flash=${encodeURIComponent('y')}` : ''}` +
                                `${this.state.report === 'y' ? `&dr=${encodeURIComponent('y')}` : ''}` +
                                `${this.state.uni === "y" ? `&unicode=${encodeURIComponent('y')}` : ''}` +
                                `${this.state.replace === 'y' && !isEinstaklingur ? `&replacements=${encodeURIComponent('y')}` : ''}` +
                                `${this.state.schedule === 'y' && !isEinstaklingur ? `&scheduled=${encodeURIComponent(this.state.date)}` : ''}`
                            ),
                        })
                        .then(response => {
                            if (response.status != 200) throw {code: response.status}
                            return response.text()
                        })
                        .then(text => {
                            if (text.includes("SUCCESS")){
                                this.successMessage(this.props.locale.messageSendSuccess);
                            }
                            else {
                                this.errorMessage(this.props.locale.messageNotSuccess);
                            }
                            history.push({pathname: "/sent", state: {expandLatest: true}});
                        })
                        .catch(error => this.errorMessage(this.props.locale.messageNotSuccess),
                        );
                    if (this.state.save && this.state.templateName) {
                        fetch(this.state.config.serverUrl + `texts/add`,
                            {
                                headers: new Headers({
                                    'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
                                    'Content-Type': 'application/json',
                                    'username': `${sessionStorage.getItem('username')}`
                                }),
                                method: 'POST',
                                body: JSON.stringify({name: this.state.templateName, text: this.state.text}),
                            })
                            .then((response) => {
                                if (response.status === 201) {
                                    this.successMessage(this.props.locale.messageTemplateSuccess);
                                } else {
                                    this.errorMessage(response.statusText);
                                }
                            })
                            .catch(error => this.errorMessage(error),
                            );
                    }
                }

            });
            setTimeout(() => {
                this.setState({isSubmitting: false});
            }, 2000); //enable the send button again
        }
    };

    handleDrop = (files) => {
        let lines = [];
        let validNumbers = [];
        let invalidNumbers = [];
        files.forEach(file => {
            const reader = new FileReader();
            reader.onload = (evt) => {
                let extension = file.name.split('.').pop();
                if (extension === "xlsx") {
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, {type: 'binary'});
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_csv(ws, {header: 1});
                    lines = data.replace(/\s+/g,'\n').replace(/,/g, '\n').split("\n").map(el => el.replace(/-/g, ''));
                }
                else if (extension === "txt") {
                    const fileAsBinaryString = reader.result;
                    lines = fileAsBinaryString.replace(/\s+/g,'\r\n').replace(/,/g, '\r\n').split("\r\n").map(el => el.replace(/-/g, ''));
                }
                validNumbers = lines.filter(isValidPhoneNumber);
                invalidNumbers = lines.filter(isInvalidPhoneNumber).filter(function (el) {return el != ""}); //also remove empty strings
                if (!this.state.files.some(x => x.name == file.name) && validNumbers.length > 0) {
                    this.state.files.push({name: file.name, numbers: validNumbers});
                    this.setState({files: this.state.files});
                }
                this.setState({invalidNumbers: invalidNumbers});
            };
            reader.readAsBinaryString(file);
        });

    }

    removeFile = (event) => {
        let files = this.state.files.filter(x => x.name != event.target.id);
        this.setState({files: files});
    }

    onNumberInput(e) {
        if (e.keyCode == 13) {
            e.preventDefault();
        }
    }

    render() {
        const Option = Select.Option;
        const Panel = Collapse.Panel;
        const RadioGroup = Radio.Group;
        return (
            <LocaleProvider locale={enUS}>
                <Form onSubmit={this.sendingRequest} className={s.form}>
                    <Dropzone activeClassName={s.dropZone} onDrop={this.handleDrop.bind(this)} style={{width: "100%"}}
                              disableClick>
                        <Form.Item
                            className={s.input_wrapper}
                            validateStatus={this.state.numberValidation ? 'success' : 'error'}
                            help={this.state.numberValidation ? '' : this.props.locale.numberValidation}
                        >
                            <span className={s.name}>{this.props.locale.numberLabel}</span>
                            <Select
                                defaultValue={this.state.defaultValue}
                                mode="tags"
                                style={{width: '100%'}}
                                size="default"
                                tokenSeparators={[',', '.', ';', ' ']}
                                name="number"
                                placeholder={this.props.locale.numberPlaceholder}
                                className={s.sms_select}
                                dropdownClassName={s.sms_select_dropdown}
                                value={this.state.number}
                                notFoundContent={''}
                                onInputKeyDown={this.onNumberInput}
                                onChange={(event) => {
                                    this.updateValidation('number', event);
                                }}
                            >
                                {this.state.contacts && this.state.contacts.map(
                                    d => <Option key={d.msisdn} value={d.msisdn}>{`${d.msisdn} - ${d.name}`}</Option>,
                                )}
                            </Select>
                            <ul className={s.fileList}>
                                {this.state.files && this.state.files.map(file =>
                                    <li>
                                    <span id={file.name} className={s.file}>
                                        {file.name} - {file.numbers.length} {this.props.locale.numberLabel}
                                        <Button id={file.name} type="link" onClick={(e) => this.removeFile(e)}><Icon type="close" className={s.removeIcon} /></Button>

                                    </span>
                                    </li>
                                )}
                            </ul>
                        </Form.Item>

                    </Dropzone>
                    <Form.Item
                        className={s.input_wrapper}
                        validateStatus={this.state.validation ? 'success' : 'error'}
                        help={this.state.validation ? '' : this.props.locale.groupValidation}
                    >
                        <span className={s.name}>{this.props.locale.groupLabel}</span>
                        <Select
                            style={{width: '100%'}}
                            size="default"
                            tokenSeparators={[',']}
                            name="group"
                            placeholder={this.props.locale.groupPlaceholder}
                            className={s.sms_select}
                            dropdownClassName={s.sms_select_dropdown}
                            value={this.state.group}
                            mode="tags"
                            onChange={(event) => {
                                this.updateValidation('group', event);
                            }}
                        >
                            {this.state.groups != null ? this.state.groups.map(
                                d => <Option key={d.id} value={d.name}>{`${d.name}(${d.members})`}</Option>,
                            ) : ""}
                        </Select>
                    </Form.Item>
                    <Form.Item className={s.input_wrapper}>
                        <span className={s.name}>{this.props.locale.senderLabel}</span>
                        <Tooltip message={this.props.locale.senderPremiumExclusiveTooltip}
                                 display={this.state.userType == userTypes.Einstaklingur}>
                            <Select
                                defaultValue={this.context.default_sender}
                                name="sender"
                                size="default"
                                className={s.sms_select}
                                value={this.state.sender}
                                dropdownClassName={s.sms_select_dropdown}
                                onChange={(event) => {
                                    this.valueChange('sender', event);
                                }}
                                showArrow={this.state.senders_list && this.state.senders_list.length > 1}
                            >
                                {this.state.senders_list && this.state.senders_list.map(
                                    d => <Option key={d} value={d}>{d}</Option>,
                                )}
                            </Select>
                        </Tooltip>
                    </Form.Item>
                    <div className={s.input_wrapper}>
                        <div className={s.input_header}>
                            <span className={s.name}>{this.props.locale.textLabel}</span>
                            {this.state.userType == userTypes.Fyrirtaeki ?
                                <Select
                                    multiple={false}
                                    name="template"
                                    placeholder={this.props.locale.templatePlaceholder}
                                    className={s.template_select}
                                    value={this.state.templateSelect}
                                    dropdownClassName={s.template_select_dropdown}
                                    onChange={(event) => {
                                        this.templateChange(event);
                                    }}
                                >
                                    {this.state.templates != null ? this.state.templates.map(
                                        d => <Option key={d.id} value={d.text}>{d.name}</Option>,
                                    ) : ""}
                                </Select>
                                : ""}
                        </div>
                        <Form.Item
                            validateStatus={this.state.textValidation ? 'success' : 'error'}
                            help={this.state.textValidation ? '' : this.props.locale.textValidation}>
                <Textarea
                    value={this.state.text}
                    rows={4}
                    className={s.textarea}
                    ontextchange={this.textChange}
                    onsavechange={this.saveChange}
                    onunicodechange={isUni => isUni ? this.state.uni = "y" : this.state.uni = "n"}
                    placeholder={this.props.locale.textLabel}
                    showsaveoption={this.state.userType == userTypes.Fyrirtaeki}
                    templatenamechange={templateName => this.state.templateName = templateName}
                />
                        </Form.Item>
                    </div>
                    <Collapse bordered={false} className={s.sms_collapse}>
                        <Panel header="Fleiri stillingar" key="1">
                            <RadioGroup
                                className={s.radio}
                                value={this.state.type}
                                onChange={(event) => {
                                    this.radioChange('type', event);
                                }}
                            >
                                <Radio value="n">
                                    <img className={s.radio_img} src={require("./option-1_active.png")}
                                         alt="SMS skilabod"/>
                                    <span className={s.radio_headline}>{this.props.locale.smsLabel}</span>
                                    <span className={s.radio_description}>{this.props.locale.smsDescription}</span>
                                </Radio>
                                <Radio value="y" disabled={this.state.userType == userTypes.Einstaklingur}>
                                    <img className={s.radio_img} src={require("./option-2_active.png")}
                                         alt="Flash skilabod"/>
                                    <span className={s.radio_headline}>{this.props.locale.flashLabel}</span>
                                    <span className={s.radio_description}>
                                            {this.props.locale.flashDescription} <Link
                                        to="/">{this.props.locale.flashLink}</Link>
                                        </span>
                                </Radio>
                            </RadioGroup>
                            <Checkbox
                                className={s.checkbox}
                                checked={this.state.report === 'y'}
                                onChange={(event) => {
                                    this.checkboxChange('report', event);
                                }}
                            >
                                <span className={s.checkbox_headline}>{this.props.locale.reportLabel}</span>
                                <span className={s.checkbox_description}>{this.props.locale.reportDescription} </span>

                            </Checkbox>

                            <Checkbox
                                className={s.checkbox}
                                checked={this.state.replace === 'y'}
                                onChange={(event) => {
                                    this.checkboxChange('replace', event);
                                }}
                                disabled={this.state.userType == userTypes.Einstaklingur}
                            >
                                <Tooltip message={this.props.locale.replacePremiumExclusiveTooltip}
                                         display={this.state.userType == userTypes.Einstaklingur}>
                                    <span className={s.checkbox_headline}>{this.props.locale.replaceLabel}</span>
                                    <span
                                        className={s.checkbox_description}>{this.props.locale.replaceDescription}</span>
                                </Tooltip>
                            </Checkbox>


                            <Checkbox
                                className={s.checkbox}
                                checked={this.state.schedule === 'y'}
                                onChange={(event) => {
                                    this.checkboxChange('schedule', event);
                                }}
                                disabled={this.state.userType == userTypes.Einstaklingur}
                            >
                                <Tooltip message={this.props.locale.scheduledPremiumExclusiveTooltip}
                                         display={this.state.userType == userTypes.Einstaklingur}>
                                    <span className={s.checkbox_headline}>{this.props.locale.scheduleLabel}</span>
                                    <span
                                        className={s.checkbox_description}>{this.props.locale.scheduleDescription} </span>
                                    <DatePicker
                                        disabled={this.state.userType == userTypes.Einstaklingur}
                                        style={{width: '180px'}}
                                        disabledDate={current => current && current.valueOf() + 86400000 < Date.now()}
                                        allowClear={false}
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        placeholder={this.props.locale.schedulePlaceholder}
                                        onChange={(event) => {
                                            this.valueChange('date', moment(event).format('YYYY-MM-DDTHH:mm:ss'));
                                        }}
                                        onOk={() => {
                                            this.setState({schedule: 'y'});
                                        }}
                                    />
                                </Tooltip>
                            </Checkbox>
                        </Panel>
                    </Collapse>
                    <div>
                        {this.state.invalidNumbers.length != 0 &&
                        <div className={s.invalidNumbersContainer}>
                            <p className={s.invalidNumbersTitle}>{this.props.locale.invalidNumbers}:</p>
                            <div className={s.invalidNumbersArea}>
                                {this.state.invalidNumbers.map(invalidNumber =>
                                    <div>
                                        {invalidNumber}
                                    </div>
                                )}
                            </div>
                        </div>
                        }
                    </div>
                    <div className={s.button_wrapper}>
                        <button className={s.btn_secondary} onClick={this.clearForm}>
                            {this.props.locale.buttonCancel}
                        </button>
                        <button className={s.btn_primary}>{this.props.locale.buttonSend}</button>
                    </div>
                </Form>
            </LocaleProvider>
        );
    }
}

export default withRouter(SendForm);



// WEBPACK FOOTER //
// ./src/routes/message/SendForm.js